<glxy-label>{{ 'INBOX.SETTINGS.PLATFORM_ASSISTANT.SUSCRIPTION_SELECTOR.TITLE' | translate }}</glxy-label>
<p class="subtitle">{{ 'INBOX.SETTINGS.PLATFORM_ASSISTANT.SUSCRIPTION_SELECTOR.DESCRIPTION' | translate }}</p>
<glxy-form-field>
  <mat-chip-grid #subscritionsChipGrid aria-label="Enter suscription levels">
    <mat-chip-row *ngFor="let level of subscriptionLevels" (removed)="removeSubscriptionLevel(level)">
      {{ level }}
      <button matChipRemove [attr.aria-label]="'remove ' + level">
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip-row>
    <input
      placeholder="{{ 'INBOX.SETTINGS.PLATFORM_ASSISTANT.SUSCRIPTION_SELECTOR.PLACEHOLDER' | translate }}"
      [matChipInputFor]="subscritionsChipGrid"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="true"
      (matChipInputTokenEnd)="addSubscriptionLevel($event)"
    />
  </mat-chip-grid>
</glxy-form-field>
